/* NORTH BORN theme JS.
   Every behaviour is a custom element, so it is automatically re-initialised
   when the Shopify theme editor re-renders a section (section reload safe). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Helpers ---------- */
  function money(cents) {
    var fmt = (window.NB && window.NB.moneyFormat) || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    var parts = val.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, Number(val).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function replaceSectionHtml(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
    if (next) {
      var drawer = current.querySelector('nb-drawer[open]');
      var trigger = drawer && drawer.trigger;
      current.innerHTML = next.innerHTML;
      var replacement = current.querySelector('nb-drawer');
      if (drawer && replacement) replacement.open(trigger);
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function trapFocus(container) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    first.focus();
  }

  /* ---------- Drawer (mobile menu + cart drawer) ---------- */
  class NbDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      if (!this.hasAttribute('role')) { this.setAttribute('role', 'dialog'); this.setAttribute('aria-modal', 'true'); }
      this.setAttribute('aria-hidden', 'true');
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nb-lock');
      var panel = this.querySelector('.drawer__panel');
      if (panel) trapFocus(panel);
    }
    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nb-lock');
      if (this.trigger && this.trigger.focus) this.trigger.focus();
    }
  }
  customElements.define('nb-drawer', NbDrawer);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target && target.open) { e.preventDefault(); target.open(opener); }
    }
  });

  /* ---------- Desktop dropdown (details/summary with hover) ---------- */
  class NbDropdown extends HTMLElement {
    connectedCallback() {
      var details = this.querySelector('details');
      if (!details) return;
      var self = this;
      var summary = details.querySelector('summary');
      var timer;
      this.addEventListener('mouseenter', function () { clearTimeout(timer); details.open = true; sync(); });
      this.addEventListener('mouseleave', function () { timer = setTimeout(function () { details.open = false; sync(); }, 120); });
      details.addEventListener('toggle', sync);
      document.addEventListener('click', function (e) { if (!self.contains(e.target)) { details.open = false; sync(); } });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') { details.open = false; sync(); summary.focus(); } });
      function sync() { summary.setAttribute('aria-expanded', details.open ? 'true' : 'false'); }
      sync();
    }
  }
  customElements.define('nb-dropdown', NbDropdown);

  /* ---------- Header search toggle ---------- */
  class NbSearchToggle extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      var targetId = this.getAttribute('for');
      if (!btn || !targetId) return;
      btn.addEventListener('click', function () {
        var bar = document.getElementById(targetId);
        if (!bar) return;
        var open = bar.hasAttribute('hidden');
        if (open) { bar.removeAttribute('hidden'); var input = bar.querySelector('input[type="search"]'); if (input) input.focus(); }
        else bar.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  customElements.define('nb-search-toggle', NbSearchToggle);

  /* ---------- Slideshow ---------- */
  class NbSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-slide-dot]'));
      this.index = 0;
      this.interval = parseInt(this.getAttribute('data-interval') || '6500', 10);
      this.autoplay = this.getAttribute('data-autoplay') === 'true' && !reduceMotion && this.slides.length > 1 && !(window.Shopify && Shopify.designMode);
      var self = this;
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); self.restart(); }); });
      var prev = this.querySelector('[data-slide-prev]'), next = this.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
      if (this.hasAttribute('data-swipe')) {
        this.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });
        this.addEventListener('pointerdown', function (e) {
          if (!e.isPrimary || e.button !== 0 || e.target.closest('a, button, input, select, textarea')) return;
          self.swipe = { id: e.pointerId, x: e.clientX, y: e.clientY };
          self.setPointerCapture(e.pointerId);
          self.stop();
        });
        this.addEventListener('pointerup', function (e) {
          var swipe = self.swipe;
          if (!swipe || swipe.id !== e.pointerId) return;
          self.swipe = null;
          var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y;
          if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            self.go(self.index + (dx < 0 ? 1 : -1));
          }
          self.restart();
        });
        this.addEventListener('pointercancel', function () { self.swipe = null; self.start(); });
      }
      this.addEventListener('mouseenter', function () { self.stop(); });
      this.addEventListener('mouseleave', function () { self.start(); });
      this.addEventListener('focusin', function () { self.stop(); });
      this.addEventListener('focusout', function () { setTimeout(function () { self.start(); }, 0); });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.go(self.index - 1); self.restart(); }
        if (e.key === 'ArrowRight') { self.go(self.index + 1); self.restart(); }
      });
      this.visible = false;
      this.visibilityHandler = function () { if (document.hidden) self.stop(); else self.start(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.observer = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) self.start(); else self.stop();
      });
      this.observer.observe(this);
      this.go(0);
      // Theme editor: show the block being edited.
      this.addEventListener('shopify:block:select', function (e) {
        var i = self.slides.indexOf(e.target.closest ? e.target.closest('[data-slide]') : null);
        if (i > -1) { self.stop(); self.go(i); }
      });
      this.addEventListener('shopify:block:deselect', function () { self.start(); });
    }
    disconnectedCallback() {
      this.stop();
      this.observer.disconnect();
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }
    go(i, automatic) {
      var n = this.slides.length; if (!n) return;
      var target = (i + n) % n;
      var slide = this.slides[target], template = slide.querySelector('template[data-slide-image]');
      if (template) {
        template.replaceWith(template.content.cloneNode(true));
        slide.querySelector('img')?.setAttribute('loading', 'eager');
      }
      var image = slide.querySelector('img'), self = this;
      // Keep the current slide visible while a slow connection loads the next image.
      if (target !== this.index && image && !image.complete) {
        if (this.pendingImage === image) return;
        this.pendingImage = image;
        image.addEventListener('load', function () {
          if (self.pendingImage !== image || !self.isConnected) return;
          self.pendingImage = null;
          if (automatic && (!self.visible || document.hidden || !self.timer)) return;
          self.go(target);
        }, { once: true });
        image.addEventListener('error', function () { self.pendingImage = null; }, { once: true });
        return;
      }
      if (image && image.complete && !image.naturalWidth && target !== this.index) return;
      this.pendingImage = null;
      this.index = target;
      this.slides.forEach(function (s, k) {
        var active = k === self.index;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.inert = !active;
        var copy = s.querySelector('.slideshow__copy');
        if (copy) { copy.classList.toggle('animate-fade-slide', active); }
      });
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === self.index ? 'true' : 'false'); });
    }
    start() { if (!this.autoplay || this.timer || !this.visible || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return; var self = this; this.timer = setInterval(function () { self.go(self.index + 1, true); }, this.interval); }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }
  customElements.define('nb-slideshow', NbSlideshow);

  /* ---------- Tabs ---------- */
  class NbTabs extends HTMLElement {
    connectedCallback() {
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;
      function select(i) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (panels[k]) { if (on) panels[k].removeAttribute('hidden'); else panels[k].setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, j = i;
          if (e.key === 'ArrowRight') j = (i + 1) % n; else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n; else return;
          e.preventDefault(); select(j); tabs[j].focus();
        });
      });
      select(0);
    }
  }
  customElements.define('nb-tabs', NbTabs);

  /* ---------- Quantity input ---------- */
  class NbQuantity extends HTMLElement {
    connectedCallback() {
      var input = this.querySelector('input');
      var self = this;
      if (!input) return;
      this.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var v = parseInt(input.value || '0', 10) + (b.name === 'plus' ? 1 : -1);
          if (v < min) v = min;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }
  customElements.define('nb-quantity', NbQuantity);

  /* ---------- Cart: shared fetch helpers ---------- */
  var cartSections = ['cart-drawer', 'cart-icon-bubble'];

  function cartRequest(url, body) {
    var page = document.querySelector('nb-cart-page');
    return fetch(url.replace(/(?:\.js)?$/, '.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: cartSections.concat(page ? [page.getAttribute('data-section-id')] : []), sections_url: window.location.pathname }))
    }).then(function (r) { return r.json(); });
  }

  function applyCartResponse(data) {
    if (data.sections) {
      Object.keys(data.sections).forEach(function (id) { replaceSectionHtml(id, data.sections[id]); });
    }
    if (typeof data.item_count === 'number') updateCartCount(data.item_count);
    else fetch(window.NB.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });
  }

  /* ---------- Cart drawer ---------- */
  class NbCartDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-line-quantity]');
        if (input) self.change(input.getAttribute('data-line-quantity'), parseInt(input.value, 10));
      });
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-line-remove'), 0); }
      });
    }
    change(line, quantity) {
      var drawer = this.closest('nb-drawer') || this;
      drawer.classList.add('is-loading');
      cartRequest(window.NB.routes.cart_change_url, { line: parseInt(line, 10), quantity: quantity })
        .then(applyCartResponse)
        .finally(function () { drawer.classList.remove('is-loading'); });
    }
  }
  customElements.define('nb-cart-drawer', NbCartDrawer);

  /* ---------- Cart page ---------- */
  class NbCartPage extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-line-quantity]');
        if (input) self.change(input.getAttribute('data-line-quantity'), parseInt(input.value, 10));
      });
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-line-remove'), 0); }
      });
    }
    change(line, quantity) {
      this.classList.add('is-loading');
      var self = this;
      cartRequest(window.NB.routes.cart_change_url, { line: parseInt(line, 10), quantity: quantity })
        .then(applyCartResponse)
        .finally(function () { self.classList.remove('is-loading'); });
    }
  }
  customElements.define('nb-cart-page', NbCartPage);

  /* ---------- Product form (AJAX add to cart) ---------- */
  class NbProductForm extends HTMLElement {
    connectedCallback() {
      var form = this.querySelector('form');
      if (!form) return;
      var self = this;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var err = self.querySelector('[data-form-error]');
        if (err) err.textContent = '';
        if (btn) { btn.setAttribute('disabled', ''); btn.classList.add('is-loading'); }
        var fd = new FormData(form);
        var body = {};
        fd.forEach(function (v, k) { body[k] = v; });
        cartRequest(window.NB.routes.cart_add_url, body)
          .then(function (data) {
            if (data.status) { if (err) err.textContent = data.description || data.message; return; }
            applyCartResponse(data);
            var drawer = document.getElementById('cart-drawer');
            if (drawer && drawer.open) drawer.open(btn); else window.location.href = window.NB.routes.cart_url;
          })
          .catch(function () { if (err) err.textContent = window.NB.strings.cartError; })
          .finally(function () { if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); } });
      });
    }
  }
  customElements.define('nb-product-form', NbProductForm);

  /* ---------- Variant picker ---------- */
  class NbVariantPicker extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('script[type="application/json"]');
      if (!json) return;
      this.variants = JSON.parse(json.textContent);
      this.sectionId = this.getAttribute('data-section');
      var self = this;
      this.addEventListener('change', function () { self.update(); });
      this.update(true);
    }
    selectedOptions() {
      return Array.prototype.map.call(this.querySelectorAll('fieldset'), function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) return checked.value;
        var sel = fs.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    update(initial) {
      var opts = this.selectedOptions();
      var variant = this.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      var root = document.getElementById('shopify-section-' + this.sectionId) || document;
      var idInput = root.querySelector('input[name="id"]');
      var btn = root.querySelector('[data-add-to-cart]');
      var btnText = root.querySelector('[data-add-to-cart-text]');
      var price = root.querySelector('[data-product-price]');
      var stock = root.querySelector('[data-stock]');
      var strings = window.NB.strings;
      this.markUnavailable(opts);
      var payment = root.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !variant || !variant.available;
      if (idInput) idInput.disabled = !variant || !variant.available;
      if (!variant) {
        if (btn) btn.setAttribute('disabled', '');
        if (btnText) btnText.textContent = strings.unavailable;
        return;
      }
      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (price) {
        var html = variant.compare_at_price > variant.price
          ? '<span class="price price--sale"><span class="price__regular">' + money(variant.compare_at_price) + '</span><span class="price__sale">' + money(variant.price) + '</span></span>'
          : money(variant.price);
        price.innerHTML = html;
      }
      if (btn && btnText) {
        if (variant.available) { btn.removeAttribute('disabled'); btnText.textContent = strings.addToCart; }
        else { btn.setAttribute('disabled', ''); btnText.textContent = strings.soldOut; }
      }
      if (stock) {
        stock.querySelector('.stock-dot').classList.toggle('stock-dot--out', !variant.available);
        stock.querySelector('span:last-child').textContent = variant.available ? strings.inStock : strings.soldOut;
      }
      if (variant.featured_media) {
        var gallery = root.querySelector('nb-gallery');
        if (gallery && gallery.showMedia && !(initial && gallery.hasAttribute('data-initial-product-media'))) gallery.showMedia(variant.featured_media.id);
      }
      if (!initial && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    markUnavailable(opts) {
      var variants = this.variants;
      this.querySelectorAll('fieldset').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return i > idx ? true : o === test[i]; }) && v.available; });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }
  }
  customElements.define('nb-variant-picker', NbVariantPicker);

  /* ---------- Product gallery ---------- */
  class NbGallery extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-media-id]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb-for]'));
      var self = this;
      this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.showMedia(t.getAttribute('data-thumb-for')); }); });
      var prev = this.querySelector('[data-media-prev]'), next = this.querySelector('[data-media-next]');
      if (prev) prev.addEventListener('click', function () { self.step(-1); });
      if (next) next.addEventListener('click', function () { self.step(1); });
      this.thumbStrip = this.classList.contains('product__gallery--carousel') && this.querySelector('.product__thumbs');
      if (this.thumbStrip) {
        var thumbPrev = this.querySelector('[data-thumbs-prev]'), thumbNext = this.querySelector('[data-thumbs-next]');
        var updateThumbArrows = function () {
          thumbPrev.disabled = self.thumbStrip.scrollLeft <= 1;
          thumbNext.disabled = self.thumbStrip.scrollLeft + self.thumbStrip.clientWidth >= self.thumbStrip.scrollWidth - 1;
        };
        [thumbPrev, thumbNext].forEach(function (button, index) {
          button.addEventListener('click', function () {
            self.thumbStrip.scrollBy({ left: (self.thumbStrip.clientWidth + 8) * (index ? 1 : -1), behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });
        this.thumbStrip.addEventListener('scroll', updateThumbArrows, { passive: true });
        this.thumbObserver = new ResizeObserver(updateThumbArrows);
        this.thumbObserver.observe(this.thumbStrip);
        updateThumbArrows();
      }
      var active = this.querySelector('.product__media.is-active') || this.items[0];
      if (active) this.showMedia(active.getAttribute('data-media-id'));
      if (this.hasAttribute('data-initial-product-media') && active) {
        var connection = navigator.connection;
        if (!connection || (!connection.saveData && !/[23]g/.test(connection.effectiveType))) {
          this.loadImage(active.querySelector('img'), 'high').then(function () {
            if (self.isConnected) self.warmTimer = setTimeout(function () { self.warmVariantImages(); }, 1200);
          }).catch(function () {});
        }
      }
    }
    loadImage(img, priority) {
      if (!img) return Promise.resolve();
      if (priority === 'high' || img.fetchPriority !== 'high') img.fetchPriority = priority;
      img.loading = 'eager';
      if (img.complete) return img.naturalWidth ? Promise.resolve() : Promise.reject(new Error('Image unavailable'));
      return new Promise(function (resolve, reject) {
        function done(event) {
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          if (event.type === 'load') resolve(); else reject(new Error('Image unavailable'));
        }
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      });
    }
    async warmVariantImages() {
      var images = this.querySelectorAll('[data-variant-media] img');
      for (var img of images) {
        if (!this.isConnected) return;
        try { await this.loadImage(img, 'low'); } catch (error) { /* Keep warming other colors. */ }
      }
    }
    async showMedia(id) {
      id = String(id);
      this.requestedMedia = id;
      var target = this.items.find(function (it) { return it.getAttribute('data-media-id') === id; });
      if (!target) return;
      if (this.hasAttribute('data-initial-product-media')) {
        var img = target.querySelector('img');
        this.setAttribute('aria-busy', 'true');
        try {
          await this.loadImage(img, 'high');
          if (img && img.decode) await img.decode();
        } catch (error) {
          if (this.requestedMedia === id) this.setAttribute('aria-busy', 'false');
          return;
        }
        if (!this.isConnected || this.requestedMedia !== id) return;
        this.setAttribute('aria-busy', 'false');
      }
      var self = this;
      this.items.forEach(function (it) {
        var on = it.getAttribute('data-media-id') === id;
        it.classList.toggle('is-active', on);
        if (!on) { var v = it.querySelector('video'); if (v) v.pause(); }
      });
      this.thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb-for') === id ? 'true' : 'false'); });
      this.current = this.items.findIndex(function (it) { return it.getAttribute('data-media-id') === id; });
      if (this.current < 0) this.current = 0;
      if (this.thumbStrip) {
        var selected = this.thumbs.find(function (t) { return t.getAttribute('data-thumb-for') === id; });
        if (selected) {
          var stripRect = this.thumbStrip.getBoundingClientRect(), thumbRect = selected.getBoundingClientRect();
          var delta = thumbRect.left < stripRect.left ? thumbRect.left - stripRect.left : thumbRect.right > stripRect.right ? thumbRect.right - stripRect.right : 0;
          if (delta) this.thumbStrip.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }
    disconnectedCallback() { if (this.thumbObserver) this.thumbObserver.disconnect(); clearTimeout(this.warmTimer); }
    step(dir) {
      var n = this.items.length; if (!n) return;
      var i = ((this.current || 0) + dir + n) % n;
      this.showMedia(this.items[i].getAttribute('data-media-id'));
    }
  }
  customElements.define('nb-gallery', NbGallery);


  class NbStoryVideo extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      var self = this, options = { signal: this.events.signal };
      var button = this.querySelector('button');
      if (button) button.addEventListener('click', function () {
        var template = self.querySelector('template');
        template.replaceWith(template.content.cloneNode(true));
        self.querySelector('button').remove();
        var video = self.querySelector('video');
        video.focus();
        video.play().catch(function () {});
      }, options);
      this.addEventListener('play', function () {
        self.closest('section').querySelectorAll('nb-story-video video').forEach(function (video) {
          if (video !== self.querySelector('video')) video.pause();
        });
      }, { capture: true, signal: this.events.signal });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) self.pause();
      }, options);
      this.observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) self.pause();
      });
      this.observer.observe(this);
    }
    pause() { var video = this.querySelector('video'); if (video) video.pause(); }
    disconnectedCallback() { this.pause(); this.events.abort(); this.observer.disconnect(); }
  }
  customElements.define('nb-story-video', NbStoryVideo);

  /* ---------- Collection sort ---------- */
  class NbSort extends HTMLElement {
    connectedCallback() {
      var select = this.querySelector('select');
      if (!select) return;
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }
  customElements.define('nb-sort', NbSort);

  /* Theme editor: open drawers when their section is selected. */
  document.addEventListener('shopify:section:select', function (e) {
    var drawer = e.target.querySelector && e.target.querySelector('nb-drawer');
    if (drawer && drawer.open) drawer.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var drawer = e.target.querySelector && e.target.querySelector('nb-drawer');
    if (drawer && drawer.close) drawer.close();
  });
})();
